




































































import Vue from 'vue';
import { Actions } from '@/store';
import { camelToKebabCase } from '@/utils';

export default Vue.extend({
  name: 'AvatarChangeModal',
  data() {
    return {
      avatar: {} as any,
      cropperConfig: {
        maxFileSizeInBytes: 5 * 1024 * 1024,
        zoomSpeedMultiplier: 4,
      },
      loader: {
        isImageUploading: false,
      },
      validationErrors: {
        invalidImageType: false,
        invalidImageSize: false,
      } as { [key: string]: boolean },
    };
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => this.resetValidation());
  },
  destroyed() {
    this.$root.$off('bv::modal::hide', () => this.resetValidation());
  },
  computed: {
    isImageInvalid(): boolean {
      return Object.values(this.validationErrors).some(e => e);
    },
    isUploadDisabled(): boolean {
      return this.isImageInvalid || !this.avatar.hasImage();
    },
    activeValidationError(): string {
      return Object.keys(this.validationErrors)[Object.values(this.validationErrors).findIndex(e => e)];
    },
  },
  methods: {
    onInit() {
      (this.avatar as any).addClipPlugin((
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        w: number,
        h: number,
      ) => {
        /*
         * ctx: canvas context
         * x: start point (top-left corner) x coordination
         * y: start point (top-left corner) y coordination
         * w: croppa width
         * h: croppa height
        */
        ctx.beginPath();
        ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI, true);
        ctx.closePath();
      });
    },
    async uploadAvatar() {
      this.loader.isImageUploading = true;
      const blob: Blob = await this.avatar.promisedBlob();
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64data = (reader.result as  string).split(',')[1];
        await this.$store.dispatch(
          Actions.geek.setAvatar,
          {
            imageType: blob.type.split('/')[1],
            data: base64data,
          },
        );
        await this.$store.dispatch(Actions.geek.fetchGeekBasicInfo);
        this.loader.isImageUploading = false;
        this.$bvModal.hide('avatar-change-modal');
      };
    },
    resetValidation() {
      for (const key in this.validationErrors) {
        if (this.validationErrors.hasOwnProperty(key)) {
          this.validationErrors[key] = false;
        }
      }
    },
    showSizeLimitErrorMessage() {
      this.validationErrors.invalidImageSize = true;
      this.avatar.remove();
    },
    showInvalidTypeErrorMessage() {
      this.validationErrors.invalidImageType = true;
      this.avatar.remove();
    },
    camelToKebabCase,
  },
});
